import { v4 as _uuidv } from "uuid";
const uuidv4 = _uuidv;
export default (function refreshId(obj, id) {
  obj.id = id || uuidv4();
  return obj;
});